import React from 'react';

const stories = [
    {
        id: 1,
        platform: 'iOS',
        user: '周女士',
        quote: '原来不是孩子长得太快，是我以前没有好好记录',
        content: '以前总觉得孩子变化不明显，直到用族语记录他的成长，从咿呀学语到跑来跑去，一下子就连成了一段清晰的成长轨迹。',
        gradient: 'from-blue-500 to-indigo-600',
        bg: 'from-white to-blue-50',
        border: 'border-blue-100',
        hover: 'from-blue-500/5 to-indigo-500/5',
        quoteColor: 'text-blue-700',
        bar: 'from-blue-400 to-indigo-500',
    },
    {
        id: 2,
        platform: 'iOS',
        user: '刘女士',
        quote: '整理爸爸的人生时，我第一次真正了解他',
        content: '以前只知道爸爸当过兵、做过生意，很多事情都是他偶尔提起。后来慢慢把他的经历整理出来，又翻出很多老照片，才发现原来他的青春也那么精彩。',
        gradient: 'from-green-500 to-emerald-600',
        bg: 'from-white to-green-50',
        border: 'border-green-100',
        hover: 'from-green-500/5 to-emerald-500/5',
        quoteColor: 'text-green-700',
        bar: 'from-green-400 to-emerald-500',
    },
    {
        id: 3,
        platform: 'Android',
        user: '李女士',
        quote: '我忽然开始期待18年后的那一天',
        content: '写那封信的时候，我脑子里一直在想：18岁的她，会是什么样子？原来有一种幸福，就是现在的我写下几句话，就能在很多年后，和长大的她完成一次对话。',
        gradient: 'from-purple-500 to-pink-600',
        bg: 'from-white to-purple-50',
        border: 'border-purple-100',
        hover: 'from-purple-500/5 to-pink-500/5',
        quoteColor: 'text-purple-700',
        bar: 'from-purple-400 to-pink-500',
    },
    {
        id: 4,
        platform: 'Harmony',
        user: '王先生',
        quote: '那些遗忘的日子，在家人的回忆里慢慢完整',
        content: '看了奶奶的人生传记才知道，原来小时候是奶奶把我带大的。原来有一种思念是读懂了她的一生，却再也来不及说一句："奶奶，谢谢您。"',
        gradient: 'from-orange-500 to-amber-600',
        bg: 'from-white to-orange-50',
        border: 'border-orange-100',
        hover: 'from-orange-500/5 to-amber-500/5',
        quoteColor: 'text-orange-700',
        bar: 'from-orange-400 to-amber-500',
    },
];

const UserStories = () => {
    return (
        <div id="stories" className="bg-gradient-to-br from-slate-50 to-purple-50 py-16 md:py-24">
            <section>
                <div className="container mx-auto px-4 md:px-8">
                    {/* 标题区域 */}
                    <div className="text-center mb-16">
                        <div className="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-6">
                            <span className="text-2xl">💬</span>
                        </div>
                        <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4">用户故事</h2>
                        <div className="w-20 h-1 bg-purple-600 mx-auto mb-6 rounded-full"></div>
                        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
                            来自真实家庭的真实感受
                        </p>
                    </div>

                    {/* 故事卡片 */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto">
                        {stories.map((story, index) => (
                            <div
                                key={story.id}
                                className={`group relative bg-gradient-to-br ${story.bg} rounded-2xl shadow-lg hover:shadow-xl transition-all duration-500 overflow-hidden border ${story.border}`}
                            >
                                <div className={`absolute inset-0 bg-gradient-to-br ${story.hover} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}></div>

                                <div className="p-7 relative">
                                    {/* 用户信息 + 评分 */}
                                    <div className="flex items-center justify-between mb-5">
                                        <div className="flex items-center gap-3">
                                            <div className={`w-11 h-11 bg-gradient-to-br ${story.gradient} rounded-full flex items-center justify-center text-white font-bold shadow-md`}>
                                                {story.user.charAt(0)}
                                            </div>
                                            <div>
                                                <p className="font-semibold text-gray-800">{story.platform}用户 · {story.user}</p>
                                                <div className="text-yellow-400 text-sm tracking-wide">★★★★★</div>
                                            </div>
                                        </div>
                                        <span className="text-5xl leading-none text-gray-200 font-serif select-none">”</span>
                                    </div>

                                    {/* 金句 */}
                                    <p className={`text-lg font-bold ${story.quoteColor} leading-snug mb-3`}>
                                        “{story.quote}”
                                    </p>

                                    {/* 正文 */}
                                    <p className="text-gray-600 leading-relaxed">
                                        {story.content}
                                    </p>
                                </div>

                                <div className={`absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r ${story.bar} transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500`}></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default UserStories;
